import { equalizer } from "./equalizer";
export { tooltip };

const tooltip = () => {
    $(document).on("click", ".tooltip-trigger", function () {
        let $this = $(this);
        let $siblingsTooltip = $this.siblings('.tooltip');
        let isVisible = $siblingsTooltip.is(":visible");
    
        if (isVisible) {
            $siblingsTooltip.hide();
            $('.tooltip-trigger-wrapper .button').hide();
        } else {
            $('.tooltip-trigger-wrapper .button').hide();
            $(".tooltip").hide();
            $this.siblings('.tooltip').show();
            $this.siblings('.button').show();
        }
    });
    $(document).on('click', ".tooltip", function () {
        let $this = $(this);
        $this.hide();
        $this.siblings(".button").hide();
    });
    $(document).on('click', ".tooltip-trigger-wrapper .button", function () {
        $(this).hide();
        $(".tooltip").hide();
    
    });
    
    $(document).on("keyup", "#automaatpakkumine", function () {
        var $this = $(this),
            val = $this.val();
    
        val = val.toString().replace(/,/g, ".");
        val = val.replace(/[^\d\.]/g, "");
        $this.val(val);
    });
    
    equalizer();
    $(window).resize(function () {
        equalizer();
    });
}